import React from 'react'
import { useDrag } from 'react-dnd'
import { DragObjectTypes } from '../../dragObjects'
import styles from './DraggableTile.module.css'
import clsx from 'clsx'
import GridSizedTile from '../grid-sized-tile'
import { TileProps } from '../tile'

export interface DraggableTileProps extends TileProps {
    id: number
}

export default function DraggableTile(props: DraggableTileProps) {
    const [{ isDragging }, drag] = useDrag({
        item: {
            type: DragObjectTypes.Tile,
            id: props.id,
            color: props.color,
            shape: props.shape,
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })
    return (
        <div ref={drag} className={clsx(styles.draggableTile, {
            [styles.dragging]: isDragging
        })}>
            <GridSizedTile {...props} />
        </div>
    )
}